import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const ZalopayPayment = () => {
  return <CommonProcess />;
};

export default ZalopayPayment;
